const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/patient.ts';
import { LOAD_PATIENT } from '@cistec/common_web/actions/patientsActions';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { getPatNrFromSession } from 'App/utils/sessionStorage';

/**
 * Loads a single patient record.
 * @param withStdAndSpecRec true=also fetch the Mandate-specific record
 * @param fullRecord true=fetch the full record rather than a partial record with the most common data
 */
export function getPatient(withStdAndSpecRec: boolean = false, fullRecord: boolean = false) {
    const patnr = getPatNrFromSession();
    const meta = { patnr, withStdAndSpecRec, fullRecord };
    return createPatapiCall(LOAD_PATIENT, 'patient', HttpMethod.GET, meta);
}
